import React, { PropsWithChildren } from 'react';

export interface IAddonContentProps extends PropsWithChildren {
    place?: 'left' | 'right';
    theme?: keyof typeof ADDON_CONTENT_THEMES;
}

const ADDON_CONTENT_THEMES = {
    accent: 'bg-blue-100 border-t border-b border-inherit',
    blank: 'bg-none border-none',
    neutral: 'bg-gray-100 border-inherit text-pale',
};

const AddonContent: React.FC<IAddonContentProps> = (props) => {
    const { theme = 'accent' } = props;
    return (
        <div
            className={`flex items-center justify-center h-12 px-4 text-md font-semibold ${props.place === 'right' ? 'border-l' : 'border-r'} ${ADDON_CONTENT_THEMES[theme]}`}
        >
            {props.children}
        </div>
    );
};

export default AddonContent;